import ExcepcionesCreate from './ExcepcionesCreate';

const indexExcepciones = {
    create: ExcepcionesCreate,
};

export default indexExcepciones;
